<div
  class="block h-10 min-w-10 max-w-40 rounded-[4px] overflow-hidden relative"
  *ngIf="file"
>
  <!-- Images -->
  <div
    class="flex justify-center items-center w-10 h-10 rounded-[4px] overflow-hidden box-border"
    *ngIf="isImage(file.type)"
  >
    <img
      *ngIf="url"
      class="w-[100%] h-[100%]"
      [src]="url"
      alt="File visualizer"
    />
  </div>

  <!-- Documents -->
  <div
    class="flex justify-center items-center gap-2 w-40 h-10 p-2 rounded-[4px] border-neutrals-300 bg-neutrals-0 box-border"
    *ngIf="isDocument(file.type)"
  >
    <ui-icon name="file-pdf" size="20" m-zise="20" fill="neutrals-600" />
    <ui-paragraph
      class="overflow-hidden text-ellipsis whitespace-nowrap"
      type="p10"
      mobile-type="p10"
      text-color="neutrals-600"
    >
      {{ file.name }}
    </ui-paragraph>
  </div>

  <!-- Delete Button Container -->
  <button
    (click)="onDelete(file.name)"
    type="button"
    *ngIf="isHovered"
    class="w-[100%] h-10 flex items-center justify-start px-[10px] bg-black bg-opacity-20 absolute top-0 left-0"
  >
    <div
      type="button"
      class="flex justify-center items-center bg-neutrals-200 w-5 h-5 rounded-[20px]"
    >
      <ui-icon name="delete" size="12" m-zise="12" fill="neutrals-900" />
    </div>
  </button>
</div>
